


import { Swiper, SwiperSlide } from 'swiper/react';
import {  Autoplay } from 'swiper/modules';
import Header  from '../components/header';
import Footer from "../components/footer";

import icon02 from "../assets/images/icons/club/2.webp"
import icon03 from "../assets/images/icons/club/3.webp"
import icon04 from "../assets/images/icons/club/4.webp"
import icon05 from "../assets/images/icons/club/5.webp"
import icon06 from "../assets/images/icons/club/6.webp"
// import icon07 from "../assets/images/icons/club/7.webp"
import icon08 from "../assets/images/icons/club/8.webp"
import icon09 from "../assets/images/icons/club/9.webp"
import icon10 from "../assets/images/newimage/icons/Golf-drive.png"
import icon11 from "../assets/images/icons/club/11.webp"
// import icon12 from "../assets/images/icons/club/12.webp"
import icon13 from "../assets/images/icons/club/13.webp"
import icon14 from "../assets/images/icons/club/14.webp"
import icon15 from "../assets/images/icons/club/15.webp"
import icon16 from "../assets/images/newimage/icons/pickle-ball-court.png"
import icon17 from "../assets/images/icons/club/17.webp"
import icon18 from "../assets/images/icons/club/18.webp"
import icon19 from "../assets/images/icons/club/Destination-wedding.png"
import icon20 from "../assets/images/newimage/icons/Squash-court-.png"
import icon21 from "../assets/images/newimage/icons/Restaurant.png"
import icon22 from "../assets/images/newimage/icons/Sand-volley-ball-court.png"


// Wander
import iconwander01 from '../assets/images/icons/Wonderplay/Swings.png'
import iconwander02 from '../assets/images/icons/Wonderplay/Totlot.png'
import iconwander03 from '../assets/images/icons/Wonderplay/Sand-Pit.png'
import iconwander04 from '../assets/images/icons/Wonderplay/Slides.png'
import iconwander05 from '../assets/images/icons/Wonderplay/Tree-House.png'
import iconwander06 from '../assets/images/icons/Wonderplay/Play-Lawn.png'
import iconwander07 from '../assets/images/icons/Wonderplay/Play-Mound.png'

import amenitieswander01 from '../assets/images/icons/Wonderplay/image-2.png'
import amenitieswander02 from '../assets/images/icons/Wonderplay/image.png'

import iconoutdoor03 from '../assets/images/icons/Outdoors/Adventure-Wall.webp'
import iconoutdoor04 from '../assets/images/icons/Outdoors/Barefoot-walkways.webp'
import iconoutdoor05 from '../assets/images/icons/Outdoors/Board-Walk.webp'
import iconoutdoor06 from '../assets/images/icons/Outdoors/Bonfire.webp'
import iconoutdoor07 from '../assets/images/icons/Outdoors/Cardio-space.webp'
import iconoutdoor08 from '../assets/images/icons/Outdoors/Hammock-Zone.webp'
import iconoutdoor09 from '../assets/images/icons/Outdoors/Interactive-Pavillion.webp'
import iconoutdoor10 from '../assets/images/icons/Outdoors/Jungle-Gym.webp'
import iconoutdoor11 from '../assets/images/icons/Outdoors/PuttingLawn.webp'
import iconoutdoor12 from '../assets/images/icons/Outdoors/Reflexology-Park.webp'
import iconoutdoor13 from '../assets/images/icons/Outdoors/Sunken-Court.webp'
import iconoutdoor15 from '../assets/images/icons/Outdoors/Therapeutic-garden.webp'
import iconoutdoor16 from '../assets/images/icons/Outdoors/Yoga-space.webp'
import iconoutdoor17 from '../assets/images/newimage/icons/Bonfire-court.png'
import iconoutdoor18 from '../assets/images/newimage/icons/Hanging-garden-.png'
import iconoutdoor19 from '../assets/images/newimage/icons/Thandi-sadak.png'
import iconoutdoor20 from '../assets/images/newimage/icons/Pond-side-Kalyani-.png'
import iconoutdoor21 from '../assets/images/newimage/icons/Interactive-pavillion.png'
import iconoutdoor22 from '../assets/images/newimage/icons/Thematic-garden.png'
import iconoutdoor23 from '../assets/images/newimage/icons/Butterfly-garden.png'
import iconoutdoor24 from '../assets/images/newimage/icons/Reading-decks.png'
import iconoutdoor25 from '../assets/images/newimage/icons/Sacred-garden.png'
import iconoutdoor26 from '../assets/images/newimage/icons/Herb-garden.png'
import iconoutdoor27 from '../assets/images/newimage/icons/Seating-alcove.png'

// Community

import iconcommunity01 from '../assets/images/icons/Community/Community-Farming.webp' 
import iconcommunity02 from '../assets/images/icons/Community/Community-Lawn.webp' 
import iconcommunity03 from '../assets/images/icons/Community/Community-Orchard.webp' 
import iconcommunity04 from '../assets/images/icons/Community/Cultural-Zone.webp' 
import iconcommunity05 from '../assets/images/icons/Community/Leisure-Garden-Pavillion.webp' 
import iconcommunity06 from '../assets/images/icons/Community/Outdoor-Reading-Pods.webp' 
import iconcommunity07 from '../assets/images/icons/Community/Pet-Park.webp' 
import iconcommunity08 from '../assets/images/newimage/icons/Seating-deck.png' 
import iconcommunity09 from '../assets/images/icons/Community/Senior-Citizen-Park.webp' 
import iconcommunity10 from '../assets/images/icons/Community/Sound-Park.webp'
import iconcommunity11 from '../assets/images/newimage/icons/Reading-pod-with-pergolas.png'
import iconcommunity12 from '../assets/images/newimage/icons/Central-park-event-spaces.png'
import iconcommunity13 from '../assets/images/newimage/icons/Activity-lawn.png'

import amenities01 from "../assets/images/amenities/1.png"
import amenities02 from "../assets/images/amenities/2.png"
import amenities03 from "../assets/images/amenities/3.png"
import amenities04 from "../assets/images/amenities/4.png"
import amenities05 from "../assets/images/amenities/5.png"

// Outdoors
import amenities06 from "../assets/images/icons/Outdoors/Outdoors-1.png"
import amenities07 from "../assets/images/icons/Outdoors/Outdoors-2.png"


// Community
import amenities08 from "../assets/images/icons/Community/Community-Space-1.webp"

// Caravan 

import amenities09 from "../assets/images/icons/Caravan/caravan-1.png"
// import amenities10 from "../assets/images/icons/Caravan/caravan-2.png"

const items = [
    {
        id:"elements-3rf29981",
        heading: 'Club Soluna',
        title: 'A Refuge Tailored to You, Shaped by Nature',
        summary: 'This is the heart of our community, a retreat woven into the earth’s quiet rhythm. A space where solitude and nature entwine, Club Soluna is your sanctuary for wellness, connection, and play.',
        banners: [
            amenities01,
            amenities02,
            amenities03,
            amenities04,
            amenities05,
        ],
        icons: [
                {
                src: icon17,
                title: "Wellness"
                },
                {
                src: icon06,
                title: "Fitness"
                },
                {
                src: icon05,
                title: "Dance Studio "
                },
                {
                src: icon15,
                title: "Table tennis "
                },
                {
                src: icon09,
                title: "Library "
                },
                {
                src: icon18,
                title: "Work Spaces "
                },
                {
                src: icon14,
                title: "Snooker "
                },
                {
                src: icon16,
                title: "Pickle Ball "
                },
                 {
                src: icon20,
                title: "Squash court"
                },
                {
                src: icon21,
                title: "Restaurant/Café"
                },
                {
                src: icon22,
                title: "Sand volley ball court"
                },
                {
                src: icon02,
                title: "Amphitheater "
                },
                {
                src: icon08,
                title: "Kids Play Area "
                },
                {
                src: icon03,
                title: "Conference "
                },
                {
                src: icon11,
                title: "Mini Theater "
                },
                {
                src: icon10,
                title: "Golf drive "
                },
                {
                src: icon13,
                title: "Retail Space "
                },
                {
                src: icon04,
                title: "Cricket Nets"
                },

                   {
                src: icon19,
                title: "Destination Wedding"
                },


                ]
    },

    {
        heading: 'Wander, Wonder, Play',
        title: 'In Harmony With Nature',
        summary: 'The community spaces at Biome  are designed for intimate gatherings and shared warmth. The sunken fire pit and social lawns create inviting environments where stories unfold under starlit skies, fostering belonging, connection, and timeless communal joy.',
        banners: [
           amenitieswander01,
           amenitieswander02
          
        ],
        icons: [
               
                {
                    src: iconwander01,
                    title: 'Swings'
                },     
                {
                    src: iconwander02,
                    title: 'Totlot'
                },     
                {
                    src: iconwander03,
                    title: 'Sand Pit'
                },     
                {
                    src: iconwander04,
                    title: 'Slides'
                },     
                {
                    src: iconwander05,
                    title: 'Tree House'
                },     
                {
                    src: iconwander06,
                    title: 'Play Lawn'
                },     
                {
                    src: iconwander07,
                    title: 'Play Mound'
                },   
               
  {
                src:iconoutdoor03,
                title:'Adventure Wall'
                },

                ]
    },
     {
       id:"elements-3rf29982",
        heading: 'The Great Outdoors',
        title: 'Between SKY & SOIL',
        summary: 'A nature inspired retreat featuring  food forests, children’s play zones, hammock areas, bonfires, walking trails, and community farms all supported by eco friendly infrastructure fostering wellness, connection, and shared joy beyond walls.',
        banners: [
            amenities06,
            amenities07,
        ],
        icons: [
              

              
                {
                src:iconoutdoor04,
                title:'Barefoot walkways'
                },
                {
                src:iconoutdoor05,
                title:'Board Walk'
                },
                {
                src:iconoutdoor06,
                title:'Bonfire'
                },
                {
                src:iconoutdoor07,
                title:'Cardio space'
                },
                {
                src:iconoutdoor08,
                title:'Hammock Zone'
                },
                {
                src:iconoutdoor09,
                title:'Interactive Pavillion'
                },
                {
                src:iconoutdoor10,
                title:'Jungle Gym'
                },
                {
                src:iconoutdoor11,
                title:'PuttingLawn'
                },
                {
                src:iconoutdoor12,
                title:'Reflexology Park'
                },
                {
                src:iconoutdoor13,
                title:'Sunken Court'
                },
                {
                src:iconoutdoor15,
                title:'Therapeutic garden'
                },
                {
                src:iconoutdoor16,
                title:'Yoga space'
                },

                {
                src:iconoutdoor17,
                title:"Bonfire court"
                },
                {
                src:iconoutdoor18,
                title:"Hanging garden"
                },
                {
                src:iconoutdoor19,
                title:"Thandi sadak"
                },
                {
                src:iconoutdoor20,
                title:"Pond side Kalyani"
                },
                {
                src:iconoutdoor21,
                title:"Interactive pavillion"
                },
                {
                src:iconoutdoor22,
                title:"Thematic garden	"
                },
                {
                src:iconoutdoor23,
                title:"Butterfly garden"
                },
                {
                src:iconoutdoor24,
                title:"Reading decks"
                },
                {
                src:iconoutdoor25,
                title:"Sacred garden"
                },
                {
                src:iconoutdoor26,
                title:"Herb garden"
                },
                {
                src:iconoutdoor27,
                title:"Seating alcove"
                },

                ]
    },
     {
       id:"elements-3rf29983",
        heading: 'Community Spaces',
        title: 'Huddle Feel the Warmth',
        summary: 'The community spaces at Biome  are designed for intimate gatherings and shared warmth. The sunken fire pit and social lawns create inviting environments where stories unfold under starlit skies, fostering belonging, connection, and timeless communal joy.',
        banners: [
            amenities08,
          
        ],
        icons: [
               
                {
                    src: iconcommunity01,
                    title: 'Community Farming'
                },     
                {
                    src: iconcommunity02,
                    title: 'Community Lawn'
                },     
                {
                    src: iconcommunity03,
                    title: 'Community Orchard'
                },     
                {
                    src: iconcommunity04,
                    title: 'Cultural Zone'
                },     
                {
                    src: iconcommunity05,
                    title: 'Leisure Garden Pavillion'
                },     
                {
                    src: iconcommunity06,
                    title: 'Outdoor Reading Pods'
                },     
                {
                    src: iconcommunity07,
                    title: 'Pet Park'
                },     
                {
                    src: iconcommunity08,
                    title: 'Seating Decks'
                },     
                {
                    src: iconcommunity09,
                    title: 'Senior Citizen Park'
                },     
                {
                    src: iconcommunity10,
                    title: 'Sound Park'
                },    

                 {
                    src: iconcommunity11,
                    title: 'Reading pod with pergolas'
                },    

                 {
                    src: iconcommunity12,
                    title: 'Central park / event spaces'
                },    

                 {
                    src: iconcommunity13,
                    title: 'Activity lawn'
                },    



                ]
    },
    
]


export default function Amenitiesz() {
  
    return (
    <div className="dody-container">
      <Header />
      <section>
          <div className="biome biome-24">
              <div
                  className="biome-element biome-element-d2ebcd8 biome-element-d2ebc9912 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky animate-section-trigger">

                  <div className="e-con-inner">
                      <div className="biome-element biome-element-6ea5a01 e-con-full e-flex e-con e-child">

                          <div
                              className="biome-element biome-element-87b503c biome-widget biome-widget-elementskit-heading animated fadeInUp">
                              <div className="biome-widget-container">
                                  <div className="ekit-wid-con">
                                      <div
                                          className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-text_center">
                                          <h1 data-anim="rotate"
                                              className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">
                                              Amenities at Biome 
                                          </h1>
                                          <p data-anim="fade-up"
                                              className="attr-h3 attr-text-white title-anim gsap-text text-center">
                                              Biome integrates nature based amenities into daily life, creating
                                              spaces for connection, wellness, play, and reflection within the shared
                                              landscape.</p>
                                      </div>
                                  </div>
                              </div>
                          </div>

                      </div>

                  </div>
              </div>
              {items.map((item, i) => (
              <div className="biome-element biome-element-c3d95c2 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white section-scroll-animation "
                  id={item.id}>
                  <div className="e-con-inner amenities-container">

                      <div className='biome-swiper-background-12 bdFadeUp' key={i}>
                          <div
                              className="e-con--inner biome-element biome-element-4cfa0db e-con-full e-flex e-con e-child">

                              <div
                                  className="biome-element biome-element-e4064a3 biome-grid-amenities-e4064a37  e-con-full e-flex e-con e-child animate-section-trigger">

                                  <div
                                      className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                                      <div className="biome-widget-container">
                                          <div className="ekit-wid-con">
                                              <div
                                                  className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                                  <h2 data-anim="rotate"
                                                      className="ekit-heading--title elementskit-section-title gsap-text">
                                                      {item.heading}<br />{item.title}</h2>
                                              </div>

                                          </div>

                                      </div>
                                  </div>
                                  <div
                                      className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                      <div className="biome-widget-container">
                                          <p data-anim="fade-up" className='title-anim gsap-text'>{item.summary}</p>
                                      </div>
                                  </div>
                                 
                              </div>

                       
         <div className="biome-element biome-element-e4064a3 biome-grid-amenities-e4064a37  e-con-full e-flex e-con e-child animate-section-trigger">
 <div
                                      className="biome-element biome-element-2a39490 biome-widget biome-widget-image animated ">
                                      <div className="biome-widget-container">

                                          <Swiper loop={true} autoplay={{
                                        delay: 10000,
                                        disableOnInteraction: false,
                                        }} slidesPerView="auto" allowTouchMove={true} modules={[ Autoplay]}>
                                              {item.banners.map((img, idx) => (
                                              <SwiperSlide>
                                                  <img className="attachment-full size-full wp-image-122" alt={img}
                                                      key={idx} sizes="(max-width: 800px) 100vw, 800px" src={img} />
                                              </SwiperSlide>
                                              ))}
                                          </Swiper>

                                      </div>
                                  </div>
         </div>
                          </div>
   
  
   
   
   <div className="biome-element biome-element-49618f26 e-con-full e-flex e-con e-child animate-section-trigger ">
                                  <div className="biome biome-577 biome-577-aminites">
                                      <div className="biome-grid biome-con-full biome-top-up">
                                          <div className="biome-row">
                                              {item.icons.map((icon, idx) => (
                                              <div className="biome-column biome-con-full biome-flex biome-child biome-grid-amenities biome-grid-amenities-12"
                                                  key={idx}>
                                                  <div className="biome-widget biome-widget-image-box">
                                                      <div className="biome-widget-container">
                                                          <div className="biome-image-box-wrapper">
                                                              <figure className="biome-image-box-img ">
                                                                  <img src={icon.src}
                                                                      sizes="(max-width: 294px) 100vw, 294px"
                                                                      width="294" height="294" decoding="async"
                                                                      alt={icon.title || "" }
                                                                      className="attachment-full size-full aminites-icon" />
                                                              </figure>
                                                              <div className="biome-image-box-content">
                                                                  <h6 data-anim="rotate"
                                                                      className="biome-image-box-title biome-grid-amenities-h6 gsap-text">
                                                                      {icon.title}</h6>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                              ))}
                                          </div>
                                      </div>
                                  </div>
                              </div>
                      </div>
                  </div>
              </div>
              ))}

              <div
                  className="biome-element biome-element-c3d95c2 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white animate-section-trigger">
                  <div className="e-con-inner">
                      <div className="biome-swiper-background-12 bdFadeUp">
                          <div
                              className="e-con--inner biome-element biome-element-4cfa0db e-con-full e-flex e-con e-child">
                              <div
                                  className="biome-element biome-element-e4064a3 biome-grid-amenities-e4064a37  e-con-full e-flex e-con e-child">
                                  <div
                                      className="biome-element biome-element-e9056c4 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                                      <div className="biome-widget-container">
                                          <div className="ekit-wid-con">
                                              <div
                                                  className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                                  <h2 data-anim="rotate"
                                                      className="ekit-heading--title elementskit-section-title gsap-text">
                                                      <span><span>Caravan
                                                              Park</span></span><br />A stay that grows where the forest
                                                      breathes
                                                  </h2>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div
                                      className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                      <div className="biome-widget-container">
                                          <p data-anim="fade-up" className="title-anim gsap-text">Biome
                                              offers nature based amenities like a shaded living
                                              canopy, food forests, and peaceful nature spots. Infrastructure includes
                                              solar power, underground water, bio sanitation, 24/7 security, and shared spaces with
                                              bonfires, lawns, trails, and community farms.</p>
                                      </div>
                                  </div>

                              </div>
                              <div className="biome-element biome-element-49618f2 e-con-full e-flex e-con e-child">
                                  <div
                                      className="biome-element biome-element-2a39490 biome-widget biome-widget-image animated">
                                      <div className="biome-widget-container">

                                          <img className="attachment-full size-full wp-image-122" alt={amenities09}
                                              sizes="(max-width: 800px) 100vw, 800px" src={amenities09} />

                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <Footer />
  </div>

    )
}